<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.5 17.5">
    <g data-name="zero value" transform="translate(.75 .75)">
      <circle data-name="Ellipse 24" cx="8" cy="8" r="8" fill="currentColor" stroke="currentColor" stroke-width="1.5"/>
    </g>
  </svg>
</template>
